<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 军校招生 -->
    <div class="military_school studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner_tool.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">什么是公费农科生？</h6>
            <div class="main_box">
                <p>公费农科生是指部分省属农业院校面向涉农专业本科生实行的，由省级财政承担其在校期间学费、教材费、住宿费并给予生活费补助（补助标准动态调整）的农科生培养管理制度。面向乡镇和基层综合便民服务机构中专项从事农技推广工作急需紧缺专业定向培养的本科生，毕业后到定向培养区域就业。由省属农业院校按照《公费农科生教育协议》进行教育培养，在校学习期间和毕业后须按照有关协议约定，履行相应的职责和义务。<br/>山东省2018年开始实施该计划，也是国内首批公费农科生的培养。2021年山西省开始首次实施该计划，山西农业大学是该省唯一公费农科生招生定点院校。</p>
            </div>    
        </div>
        <div class="benefit main">
            <h6 class="main_title">报考条件</h6>
            <div class="main_box">
                <p>(1)热爱“三农”事业，毕业后志愿到乡镇和基层综合便民服务机构工作，具备当年普通高考报考条件，参加普通高校招生全国统一考试，达到招生院校在本地区的录取分数线；</p>
                <p>(2)报考公费农科生的考生须自愿承诺签订并履行《公费农科生教育协议》；</p>
                <p>(3)身体健康，体检标准严格按《普通高等学校招生体检工作指导意见》执行；</p>
            </div>
        </div>
        <div class="benefit main">
            <h6 class="main_title">培养政策</h6>
            <div class="main_box">
                <p>(1)公费农科生在校学习期间，由省财政承担其学费、教材费、住宿费并给予生活费补助(补助标准动态调整)。</p>
                <p>(2)公费农科生毕业后到乡镇和基层综合便民服务机构定向就业,入职时签订事业单位人员聘用合同,纳入事业编制实名制管理,一般合同期为5年。合同期满,严格实施聘期考核,聘期考核不合格的,不再续签聘用合同。</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            universities: [
                {school_name:"北京大学",},
                {school_name:"中国人民大学",},
                {school_name:"清华大学",},
                {school_name:"北京航空航天大学",},
                {school_name:"北京理工大学",},
                {school_name:"中国农业大学",},
                {school_name:"北京师范大学",},
                {school_name:"中央民族大学",},
                {school_name:"南开大学",},
                {school_name:"天津大学",},
                {school_name:"大连理工大学",},
                {school_name:"吉林大学",},
                {school_name:"哈尔滨工业大学",},
                {school_name:"复旦大学",},
                {school_name:"同济大学",},
                {school_name:"上海交通大学",},
                {school_name:"华东师范大学",},
                {school_name:"南京大学",},
                {school_name:"东南大学",},
                {school_name:"浙江大学",},
                {school_name:"中国科学技术大学",},
                {school_name:"厦门大学",},
                {school_name:"山东大学",},
                {school_name:"中国海洋大学",},
                {school_name:"武汉大学",},
                {school_name:"华中科技大学",},
                {school_name:"中南大学",},
                {school_name:"中山大学",},
                {school_name:"华南理工大学",},
                {school_name:"四川大学",},
                {school_name:"重庆大学",},
                {school_name:"电子科技大学",},
                {school_name:"西安交通大学",},
                {school_name:"西北工业大学",},
                {school_name:"兰州大学",} ,
                {school_name:"国防科技大学",}                
            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: 'yuanxiaoxiangqing',
                query: {
                    id: id,
                }
            })
            // window.open(href, '_blank');
             this.$router.push('/explore/yuanxiaoxiangqing?id='+id)
        }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .military_school {
        .liucheng {
            ul {
                display: flex;
                flex-wrap: wrap;
                li {
                    text-align: center;
                    line-height: 50px;
                    /* width: 189px; */
                    height: 50px;
                    /* padding-right: 60px; */
                    background: url(/imgs/wayToStudy/common/icon_liucheng.png) no-repeat right center;
                    margin-right: 20px;
                    padding-right: 53px;
                    background-size: 20px 20px;
                    // &:last-child {
                    //     padding-right: 0px;
                    // }
                }
            }
        }
        .universities  ul {
            overflow: hidden;
            width: 933px;
            li {
                font-size: 14px;
                box-sizing: border-box;
                float: left;
                width: 25%;
                border: 1px solid #eaeaea;
                margin-left: -1px;
                margin-top: -1px;
                min-height: 42px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 20px;
                text-align: center;
                &:nth-child(4n+1) {
                    margin-left: 0px;
                }
                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }
            }
    }
        
    }
    
</style>